import Avatar from '../../../compoment/Avatar';

const ImagesAvatar = ({ user }) => {
  if (!user) return null;

  const hasName = !!user.full_name && user.full_name.trim() !== '';

  return (
    <div
      className="item-img"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '4px',
      }}
    >
      {user.avatar_url ? (
        <img
          className="img-user"
          src={user.avatar_url}
          alt={user.full_name || 'avatar'}
        />
      ) : hasName ? (
        <Avatar fullName={user.full_name} />
      ) : (
        <div className="img-user" style={{ width: '100%', aspectRatio: 1 }} />
      )}
    </div>
  );
};

export default ImagesAvatar;
